/*=========================================================================================
  File Name: moduleSchedule.js
  Description: Schedule Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleFrequencyState.js";
import mutations from "./moduleFrequencyMutations.js";
import actions from "./moduleFrequencyActions.js";
import getters from "./moduleFrequencyGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
